import { render } from "./medical-details.vue?vue&type=template&id=7cf7d9b3"
import script from "./medical-details.vue?vue&type=script&lang=js"
export * from "./medical-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__